import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import { useEffect, useState } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import styled from "styled-components";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { Fingerprint, Business, Description, VpnKey, Storage, Link as LinkIcon, AccountCircle, Lock, InsertLink, LinkOff } from "@material-ui/icons";
import fetchClient from "../../../api/fetchClient";

function TabEmpresaComerzzia({
  values,
  touched,
  errors,
  handleChange,
  onTestConnect,
  onTestConnectHana,
  connected,
  connectedHana,
  isLoading,
  isLoadingHana
}) {
  const [grupos, setGrupos] = useState([]);

  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        const { data } = await fetchClient.get("/wms/getAllGroups");
        setGrupos(data);
      } catch (error) {
        console.error("Erro ao buscar grupos:", error);
      }
    };

    fetchGrupos();
  }, []);

  return (
    <>
      <SectionTitle>Informações Gerais</SectionTitle>
      <FormGrid columns={2} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <Fingerprint style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            ID
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            disabled
            id="id"
            name="id"
            placeholder="ID"
            value={values.id}
            onChange={handleChange}
            error={touched.id && Boolean(errors.id)}
            helperText={touched.id && errors.id}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <Business style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Grupo
          </FieldLabel>
          <TextField
            select
            fullWidth
            id="grupoId"
            name="grupoId"
            placeholder="Selecione um grupo"
            value={values.grupoId || ""}
            onChange={handleChange}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            error={touched.grupoId && Boolean(errors.grupoId)}
            helperText={touched.grupoId && errors.grupoId}
          >
            {grupos.map((grupo) => (
              <MenuItem key={grupo.id} value={grupo.id}>
                {grupo.id}
              </MenuItem>
            ))}
          </TextField>
        </StyledFieldContainer>
      </FormGrid>

      <FormGrid columns={2} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <Description style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Inscrição Estadual
          </FieldLabel>
          <TextField
            fullWidth
            id="inscricao_estadual"
            name="inscricao_estadual"
            placeholder="Ex: 123.456.789.012"
            value={values.inscricao_estadual || ""}
            onChange={handleChange}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            error={touched.inscricao_estadual && Boolean(errors.inscricao_estadual)}
            helperText={touched.inscricao_estadual && errors.inscricao_estadual}
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <CheckboxContainer>
            <Checkbox
              id="enabled"
              name="enabled"
              checked={values.enabled}
              onChange={(e) => handleChange({ target: { name: "enabled", value: e.target.checked } })}
              color="primary"
            />
            <CheckboxLabel>{values.enabled ? "Aplicação Ativa" : "Aplicação Inativa"}</CheckboxLabel>
          </CheckboxContainer>
        </StyledFieldContainer>
      </FormGrid>

      <FormGrid columns={3}>
        <StyledFieldContainer>
          <FieldLabel>
            <Business style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            CNPJ
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="cnpj"
            name="cnpj"
            placeholder="00.000.000/0000-00"
            value={values.cnpj}
            onChange={handleChange}
            error={touched.cnpj && Boolean(errors.cnpj)}
            helperText={touched.cnpj && errors.cnpj}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <Business style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Nome
          </FieldLabel>
          <TextField
            InputLabelProps={{ shrink: true }}
            fullWidth
            id="name"
            name="name"
            placeholder="Nome da empresa"
            value={values.name}
            onChange={handleChange}
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && errors.name}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <Description style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Descrição
          </FieldLabel>
          <TextField
            InputLabelProps={{ shrink: true }}
            fullWidth
            id="description"
            name="description"
            placeholder="Descrição da empresa"
            value={values.description}
            onChange={handleChange}
            error={touched.description && Boolean(errors.description)}
            helperText={touched.description && errors.description}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <SectionTitleContainer hidden={values.id === 0}>
        <SectionTitle>Configuração SAP</SectionTitle>
        {onTestConnect && (
          <ConnectionButton
            onClick={onTestConnect}
            connected={connected}
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={18} style={{ color: 'white' }} />
            ) : (
              <Tooltip title={connected ? "Conectado ao SAP" : "Testar conexão SAP"}>
                {connected ? <InsertLink /> : <LinkOff />}
              </Tooltip>
            )}
          </ConnectionButton>
        )}
      </SectionTitleContainer>
      <FormGrid columns={1} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <LinkIcon style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            URL Service Layer SAP
          </FieldLabel>
          <TextField
            InputLabelProps={{ shrink: true }}
            fullWidth
            id="url"
            name="url"
            placeholder="https://servicelayer.sample:00000/b1s/v1"
            value={values.url}
            onChange={handleChange}
            error={touched.url && Boolean(errors.url)}
            helperText={touched.url && errors.url}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <SectionTitleContainer hidden={values.id === 0}>
        <SectionTitle>Configuração HANA</SectionTitle>
        {onTestConnectHana && (
          <ConnectionButton
            onClick={onTestConnectHana}
            connected={connectedHana}
            disabled={isLoadingHana}
          >
            {isLoadingHana ? (
              <CircularProgress size={18} style={{ color: 'white' }} />
            ) : (
              <Tooltip title={connectedHana ? "Conectado ao HANA" : "Testar conexão HANA"}>
                {connectedHana ? <InsertLink /> : <LinkOff />}
              </Tooltip>
            )}
          </ConnectionButton>
        )}
      </SectionTitleContainer>
      <FormGrid columns={3} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <LinkIcon style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            URL Hana SQL
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="urlHanaSql"
            name="urlHanaSql"
            placeholder="https://hana-server:30015"
            value={values.urlHanaSql}
            onChange={handleChange}
            error={touched.urlHanaSql && Boolean(errors.urlHanaSql)}
            helperText={touched.urlHanaSql && errors.urlHanaSql}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Hana UserName
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="hUserName"
            name="hUserName"
            placeholder="Usuário do HANA"
            value={values.hUserName}
            onChange={handleChange}
            error={touched.hUserName && Boolean(errors.hUserName)}
            helperText={touched.hUserName && errors.hUserName}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Hana Password
          </FieldLabel>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            id="hPassword"
            name="hPassword"
            placeholder="••••••••"
            type="password"
            value={values.hPassword}
            onChange={handleChange}
            error={touched.url && Boolean(errors.hPassword)}
            helperText={touched.hPassword && errors.hPassword}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <SectionTitle>Credenciais SAP</SectionTitle>
      <FormGrid columns={3}>
        <StyledFieldContainer>
          <FieldLabel>
            <Storage style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Banco de dados SAP
          </FieldLabel>
          <TextField
            InputLabelProps={{ shrink: true }}
            fullWidth
            id="database"
            name="database"
            placeholder="Nome do banco de dados"
            value={values.database}
            onChange={handleChange}
            error={touched.database && Boolean(errors.database)}
            helperText={touched.database && errors.database}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Login SAP
          </FieldLabel>
          <TextField
            InputLabelProps={{ shrink: true }}
            fullWidth
            id="login"
            name="login"
            placeholder="Usuário do SAP"
            value={values.login}
            onChange={handleChange}
            error={touched.login && Boolean(errors.login)}
            helperText={touched.login && errors.login}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
        <StyledFieldContainer>
          <FieldLabel>
            <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Senha SAP
          </FieldLabel>
          <TextField
            InputLabelProps={{ shrink: true }}
            fullWidth
            id="password"
            name="password"
            placeholder="••••••••"
            type="password"
            value={values.password}
            onChange={handleChange}
            error={touched.password && Boolean(errors.password)}
            helperText={touched.password && errors.password}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <FormGrid columns={1} hidden={values.id === 0}>
        <StyledFieldContainer>
          <FieldLabel>
            <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#84cc16' }} />
            Token
          </FieldLabel>
          <TextField
            InputLabelProps={{ shrink: true }}
            fullWidth
            id="token"
            name="token"
            placeholder="Token de autenticação"
            value={values.token}
            disabled
            error={touched.token && Boolean(errors.token)}
            helperText={touched.token && errors.token}
            autoComplete="off"
            variant="outlined"
          />
        </StyledFieldContainer>
      </FormGrid>

      <FormGrid columns={1} hidden={values.id === 0}>
        <CheckboxContainer>
          <Checkbox
            id="metadata"
            name="metadata"
            checked={values.metadata}
            onChange={handleChange}
            color="primary"
          />
          <CheckboxLabel>Habilitar criação de tabelas e campos no SAP</CheckboxLabel>
        </CheckboxContainer>
      </FormGrid>
    </>
  );
}

export default TabEmpresaComerzzia;

const SectionTitleContainer = styled.div`
  display: ${props => props.hidden ? 'none' : 'flex'};
  align-items: center;
  justify-content: space-between;
  margin: 24px 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const ConnectionButton = styled.button`
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  background: ${props => {
    if (props.disabled) return '#e0e0e0';
    return props.connected
      ? 'linear-gradient(135deg, #27ae60 0%, #229954 100%)'
      : 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)';
  }};
  color: white;

  &:hover {
    transform: ${props => props.disabled ? 'none' : 'scale(1.1)'};
    box-shadow: ${props => {
      if (props.disabled) return 'none';
      return props.connected
        ? '0 4px 12px rgba(39, 174, 96, 0.4)'
        : '0 4px 12px rgba(243, 156, 18, 0.4)';
    }};
  }

  svg {
    font-size: 20px;
  }
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 1}, 1fr);
  gap: 20px;
  margin-bottom: 24px;
  display: ${props => props.hidden ? 'none' : 'grid'};

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .MuiOutlinedInput-root {
    border-radius: 10px;
    background: white;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(132, 204, 22, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(132, 204, 22, 0.2);
    }
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
  }

  .MuiInputLabel-outlined {
    font-family: 'Mulish', sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: rgba(132, 204, 22, 0.05);
  border-radius: 10px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(132, 204, 22, 0.1);
  }
`;

const CheckboxLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  font-family: 'Mulish', sans-serif;
`;
